import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "cell-item"
};
const _hoisted_2 = {
  class: "cell-item"
};
const _hoisted_3 = {
  class: "cell-item"
};
const _hoisted_4 = {
  class: "cell-item"
};
const _hoisted_5 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_6 = {
  class: "infoCard_box",
  style: {}
};
const _hoisted_7 = {
  key: 0,
  class: "infoCard_boxnet",
  style: {}
};
const _hoisted_8 = {
  class: "infoCard_boxinp",
  style: {}
};
const _hoisted_9 = {
  class: "infoCard_boxinp"
};
const _hoisted_10 = {
  class: "infoCard_boxinp"
};
const _hoisted_11 = {
  class: "infoCard"
};
const _hoisted_12 = {
  class: "infoCard_box3",
  style: {}
};
const _hoisted_13 = {
  class: "infoCard_box3text",
  style: {}
};
const _hoisted_14 = {
  class: "infoCard_box3net",
  style: {}
};
const _hoisted_15 = {
  class: "infoCard_box3netboy",
  style: {}
};
const _hoisted_16 = {
  class: "infoCard_box3netboytxtr",
  style: {}
};
const _hoisted_17 = {
  class: "infoCard_box3netboy",
  style: {}
};
const _hoisted_18 = {
  class: "infoCard_box3netboytxtr"
};
const _hoisted_19 = {
  class: "infoCard_box3netboy",
  style: {}
};
const _hoisted_20 = {
  class: "infoCard_box3netboytxtr2"
};
const _hoisted_21 = {
  class: "infoCard_box3"
};
const _hoisted_22 = {
  class: "footcard"
};
const _hoisted_23 = {
  class: "footcardnet",
  style: {}
};
const _hoisted_24 = {
  style: {
    "margin": "0 auto",
    "text-align": "center"
  }
};
const _hoisted_25 = {
  style: {
    "margin": "0 auto",
    "text-align": "center"
  }
};
const _hoisted_26 = {
  style: {
    "margin": "0 auto",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_user = _resolveComponent("user");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_iphone = _resolveComponent("iphone");
  const _component_location = _resolveComponent("location");
  const _component_tickets = _resolveComponent("tickets");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_upload = _resolveComponent("el-upload");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("text", null, "检测员/核对人员：" + _toDisplayString($data.orderAreaDevice.userAlias), 1), _createVNode(_component_el_descriptions, {
        class: "margin-top",
        title: "设备信息",
        column: 3,
        size: _ctx.size,
        border: ""
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => $options.update($data.vDeviceArea))
        }, {
          default: _withCtx(() => [...(_cache[139] || (_cache[139] = [_createTextVNode("查看/修改", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_icon, {
            style: _normalizeStyle(_ctx.iconStyle)
          }, {
            default: _withCtx(() => [_createVNode(_component_user)]),
            _: 1
          }, 8, ["style"]), _cache[140] || (_cache[140] = _createTextVNode(" 使用单位代码 ", -1))])]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.vDeviceArea.unitCode), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_icon, {
            style: _normalizeStyle(_ctx.iconStyle)
          }, {
            default: _withCtx(() => [_createVNode(_component_iphone)]),
            _: 1
          }, 8, ["style"]), _cache[141] || (_cache[141] = _createTextVNode(" 产品编号 ", -1))])]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.vDeviceArea.liftNum), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, {
            style: _normalizeStyle(_ctx.iconStyle)
          }, {
            default: _withCtx(() => [_createVNode(_component_location)]),
            _: 1
          }, 8, ["style"]), _cache[142] || (_cache[142] = _createTextVNode(" 设备品种 ", -1))])]),
          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.vDeviceArea.liftType), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
            style: _normalizeStyle(_ctx.iconStyle)
          }, {
            default: _withCtx(() => [_createVNode(_component_tickets)]),
            _: 1
          }, 8, ["style"]), _cache[143] || (_cache[143] = _createTextVNode(" 使用单位 ", -1))])]),
          default: _withCtx(() => [_createVNode(_component_el_tag, {
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.vDeviceArea.unit), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["size"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[147] || (_cache[147] = _createElementVNode("span", {
        style: {
          "float": "left",
          "font-size": "16px",
          "font-weight": "700"
        }
      }, "现场条件：", -1)), _createVNode(_component_el_checkbox_group, {
        modelValue: $data.saveID,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.saveID = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.explainList, item => {
          return _openBlock(), _createBlock(_component_el_checkbox, {
            label: item.explainId,
            key: item.explainId,
            onChange: $options.handleCheckedCitiesChange,
            checked: $data.saveID.includes(item.explainId)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
              style: _normalizeStyle(item.explainId === 1 ? 'line-height: 3;' : '')
            }, _toDisplayString(item.explainName), 5), item.explainId === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[144] || (_cache[144] = _createElementVNode("span", null, "温度(℃):", -1)), _createVNode(_component_el_input, {
              modelValue: $data.temp,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.temp = $event),
              placeholder: "请输入温度(℃)",
              class: "search-input"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_cache[145] || (_cache[145] = _createElementVNode("text", null, "湿度(%):", -1)), _createVNode(_component_el_input, {
              modelValue: $data.humidity,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.humidity = $event),
              placeholder: "请输入湿度(%)",
              class: "search-input"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_cache[146] || (_cache[146] = _createElementVNode("text", null, "电压(V):", -1)), _createVNode(_component_el_input, {
              modelValue: $data.voltage,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.voltage = $event),
              placeholder: "请输入电压(V)",
              class: "search-input"
            }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["label", "onChange", "checked"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), $data.vDeviceArea.lifeKind === '自动扶梯与自动人行道' ? (_openBlock(), _createBlock(_component_el_descriptions, {
        key: 0,
        class: "margin-top",
        title: "观测数据及测量结果记录",
        size: _ctx.size,
        border: ""
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.toObserved
        }, {
          default: _withCtx(() => [...(_cache[148] || (_cache[148] = [_createTextVNode("查看/修改", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }, 8, ["size"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions, {
        class: "margin-top",
        title: "检测场景"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.moduleList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("text", _hoisted_13, _toDisplayString(item), 1), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => $options.queryHoistway(item),
          class: "infoCard_box3but",
          style: {},
          size: "mini"
        }, {
          default: _withCtx(() => [...(_cache[149] || (_cache[149] = [_createTextVNode("查看/修改", -1)]))]),
          _: 1
        }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[150] || (_cache[150] = _createElementVNode("text", {
          class: "infoCard_box3netboytxtl",
          style: {}
        }, "检查项目 ", -1)), _createElementVNode("text", _hoisted_16, _toDisplayString($data.detectioncount[index]), 1)]), _createElementVNode("div", _hoisted_17, [_cache[151] || (_cache[151] = _createElementVNode("text", {
          class: "infoCard_box3netboytxtl"
        }, "检查合格项 ", -1)), _createElementVNode("text", _hoisted_18, _toDisplayString($data.successList[index]), 1)]), _createElementVNode("div", _hoisted_19, [_cache[152] || (_cache[152] = _createElementVNode("text", {
          class: "infoCard_box3netboytxtl"
        }, "检查不合格项 ", -1)), _createElementVNode("text", _hoisted_20, _toDisplayString($data.falseList[index]), 1)])]), _createElementVNode("div", null, [_createVNode(_component_el_progress, {
          style: {},
          percentage: $data.pgList[index],
          "stroke-width": 18
        }, null, 8, ["percentage"])])])]);
      }), 128)), _createVNode(_component_el_descriptions, {
        class: "margin-top",
        title: "备注"
      }), _createVNode(_component_el_input, {
        type: "textarea",
        placeholder: "请输入内容",
        modelValue: $data.Record.notes,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.Record.notes = $event),
        maxlength: "1000",
        "show-word-limit": ""
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_date_picker, {
        onChange: $options.detectionDateChange,
        modelValue: this.Record.recDate,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => this.Record.recDate = $event),
        type: "date",
        placeholder: "检测日期",
        format: "YYYY年MM月DD日",
        style: {
          "width": "300px"
        }
      }, null, 8, ["onChange", "modelValue"]), _createVNode(_component_el_date_picker, {
        onChange: $options.csDateChange,
        modelValue: this.Record.csignDate,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => this.Record.csignDate = $event),
        type: "date",
        placeholder: "签收日期",
        format: "YYYY年MM月DD日",
        style: {
          "width": "300px"
        }
      }, null, 8, ["onChange", "modelValue"])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 24
    }, {
      default: _withCtx(() => [_createElementVNode("view", _hoisted_22, [_createElementVNode("view", null, [_createVNode(_component_el_button, {
        class: "nextBut",
        style: {},
        type: "primary",
        onClick: _cache[8] || (_cache[8] = $event => $options.creatReport(1))
      }, {
        default: _withCtx(() => [...(_cache[153] || (_cache[153] = [_createTextVNode("预览生成检测报告", -1)]))]),
        _: 1
      })]), _createElementVNode("view", null, [_createVNode(_component_el_button, {
        class: "nextBut",
        style: {},
        type: "primary",
        onClick: _cache[9] || (_cache[9] = $event => $options.createRecord($data.Record, 1))
      }, {
        default: _withCtx(() => [...(_cache[154] || (_cache[154] = [_createTextVNode("预览生成检测记录", -1)]))]),
        _: 1
      })]), _createElementVNode("view", null, [_createVNode(_component_el_button, {
        class: "nextBut",
        style: {},
        type: "primary",
        onClick: _cache[10] || (_cache[10] = $event => $options.creatReport(0))
      }, {
        default: _withCtx(() => [...(_cache[155] || (_cache[155] = [_createTextVNode("生成检测报告", -1)]))]),
        _: 1
      })]), _createElementVNode("view", null, [_createVNode(_component_el_button, {
        class: "nextBut2",
        style: {},
        type: "primary",
        onClick: $options.TocreatNotice
      }, {
        default: _withCtx(() => [...(_cache[156] || (_cache[156] = [_createTextVNode("生成备忘录", -1)]))]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("view", _hoisted_23, [_createVNode(_component_el_button, {
        class: "nextBut2",
        style: {},
        type: "primary",
        onClick: $options.clickBack
      }, {
        default: _withCtx(() => [...(_cache[157] || (_cache[157] = [_createTextVNode("退回", -1)]))]),
        _: 1
      }, 8, ["onClick"])])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisibleEdit,
    "onUpdate:modelValue": _cache[132] || (_cache[132] = $event => $data.dialogFormVisibleEdit = $event),
    title: "编辑设备",
    "lock-scroll": false,
    width: "80%"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_button, {
      onClick: _cache[130] || (_cache[130] = $event => _ctx.closeDialog(1, 'editform'))
    }, {
      default: _withCtx(() => [...(_cache[158] || (_cache[158] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[131] || (_cache[131] = $event => $options.edit('editform'))
    }, {
      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: $data.editform,
          inline: true,
          ref: "editform",
          rules: _ctx.rules,
          "status-icon": "",
          "label-width": "140px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备种类",
                prop: "unit",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.specialType,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.editform.specialType = $event),
                  disabled: "true",
                  placeholder: "请选择设备种类",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "电梯",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "起重器",
                    value: 2
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用单位名称",
                prop: "unit",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.unit,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.editform.unit = $event),
                  style: {
                    "width": "300px"
                  },
                  placeholder: "请输入使用单位名称",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "监察识别码",
                style: {
                  "width": "440px"
                },
                prop: "superviseCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.superviseCode,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.editform.superviseCode = $event),
                  style: {
                    "width": "300px"
                  },
                  placeholder: "请输入监察识别码",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "额定载重量",
                prop: "maxWeight",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.maxWeight,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.editform.maxWeight = $event),
                  precision: 1,
                  step: 1,
                  min: 0,
                  max: 10000
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备使用地点",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.areaParentIdOne,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.areaParentIdOne = $event),
                  placeholder: "请选择",
                  onChange: _ctx.queryAreaList2,
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList, (item, key) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.areaName,
                      value: key
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.areaParentIdTwo,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.areaParentIdTwo = $event),
                  placeholder: "请选择",
                  onChange: _ctx.queryAreaList3,
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList2, (item, key) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.areaName,
                      value: key
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.areaParentIdThree,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.areaParentIdThree = $event),
                  placeholder: "请选择",
                  onChange: _ctx.queryAreaList4,
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList3, (item, key) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item.areaName,
                      value: key
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_input, {
                  modelValue: $data.editform.detailArea,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.editform.detailArea = $event),
                  placeholder: "请输入具体地址",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "500",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "额定压力",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.pressure,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.editform.pressure = $event),
                  placeholder: "请输入额定压力",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "额定速度",
                prop: "speed",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.speed,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.editform.speed = $event),
                  precision: 2,
                  step: 0.1,
                  min: 0,
                  max: 100
                }, null, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "额定速度（上行）",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.speedUp,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.editform.speedUp = $event),
                  precision: 2,
                  step: 0.1,
                  min: 0,
                  max: 100
                }, null, 8, ["modelValue"])]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备所在区域",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.lifeArea,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.editform.lifeArea = $event),
                  placeholder: "请输入设备所在区域",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "楼盘名称",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.propertyName,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.editform.propertyName = $event),
                  placeholder: "请输入楼盘名称",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "分支机构名称",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.branchName,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.editform.branchName = $event),
                  placeholder: "请输入分支机构名称",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "驱动主机型号",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.driveModel,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.editform.driveModel = $event),
                  placeholder: "请输入驱动主机型号",
                  min: 0,
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "驱动主机编号",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.driveCode,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.editform.driveCode = $event),
                  placeholder: "请输入驱动主机编号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "控制柜型号",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.controlBoxModel,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.editform.controlBoxModel = $event),
                  placeholder: "请输入控制柜型号",
                  min: 0,
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "控制柜编号",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.controlBoxCode,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.editform.controlBoxCode = $event),
                  placeholder: "请输入控制柜编号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "轿厢限速器型号",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.carModel,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.editform.carModel = $event),
                  placeholder: "请输入轿厢限速器型号",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "轿厢限速器编号",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.carCode,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.editform.carCode = $event),
                  placeholder: "请输入轿厢限速器编号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "对重限速器型号",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.counterweightModel,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.editform.counterweightModel = $event),
                  placeholder: "请输入对重限速器型号",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "对重限速器编号",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.counterweightModelCode,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $data.editform.counterweightModelCode = $event),
                  placeholder: "请输入对重限速器编号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用单位地址",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.unitArea,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.editform.unitArea = $event),
                  placeholder: "请输入使用单位地址",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "分支机构地址",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.branchArea,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.editform.branchArea = $event),
                  placeholder: "请输入分支机构地址",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "楼盘地址",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.propertyArea,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.editform.propertyArea = $event),
                  placeholder: "请输入楼盘地址",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "上次检验日期格式",
                prop: "preDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.preDateType,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.editform.preDateType = $event),
                  onChange: _cache[37] || (_cache[37] = $event => _ctx.getDateType($data.editform.preDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "上次检验日期",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.preDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.preDate,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.editform.preDate = $event),
                  type: "date",
                  placeholder: "上次检验日期",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.preDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.preDate,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => $data.editform.preDate = $event),
                  type: "date",
                  placeholder: "上次检验日期",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.preDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.preDate,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $data.editform.preDate = $event),
                  type: "date",
                  placeholder: "上次检验日期",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "制造时间日期格式",
                prop: "createDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.createDateType,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.editform.createDateType = $event),
                  onChange: _cache[42] || (_cache[42] = $event => _ctx.getDateType($data.editform.createDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "制造时间",
                class: "rightStyle",
                prop: "createDate"
              }, {
                default: _withCtx(() => [$data.editform.createDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.createDate,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $data.editform.createDate = $event),
                  type: "date",
                  placeholder: "制造时间",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.createDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.createDate,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.editform.createDate = $event),
                  type: "date",
                  placeholder: "制造时间",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.createDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.createDate,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $data.editform.createDate = $event),
                  type: "date",
                  placeholder: "制造时间",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "额定速度（下行）",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input_number, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.speedDown,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => $data.editform.speedDown = $event),
                  precision: 2,
                  step: 0.1,
                  min: 0,
                  max: 100
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "油缸数量",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.hcNum,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.editform.hcNum = $event),
                  placeholder: "请输入油缸数量",
                  min: 0,
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "满载压力",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.maxPressure,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.editform.maxPressure = $event),
                  min: 0,
                  placeholder: "请输入满载压力",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用单位代码",
                prop: "unitCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.unitCode,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.editform.unitCode = $event),
                  placeholder: "请输入使用单位代码",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "层",
                class: "rightStyle",
                prop: "storey"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  min: 0,
                  modelValue: $data.editform.storey,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.editform.storey = $event),
                  placeholder: "请输入层数",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用登记证编号",
                prop: "loginNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.loginNum,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.editform.loginNum = $event),
                  class: "rightStyle",
                  placeholder: "请输入使用登记证编号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "站",
                class: "rightStyle",
                prop: "stand"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.stand,
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.editform.stand = $event),
                  placeholder: "请输入站数",
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "单位内编码",
                class: "rightStyle",
                prop: "unitNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.unitNum,
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => $data.editform.unitNum = $event),
                  placeholder: "请输入单位内编码",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "门",
                class: "rightStyle",
                prop: "door"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.door,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $data.editform.door = $event),
                  min: 0,
                  placeholder: "请输入门数",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备注册代码",
                class: "rightStyle",
                prop: "lifeRegistCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.lifeRegistCode,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => $data.editform.lifeRegistCode = $event),
                  placeholder: "请输入设备注册代码",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "控制方式",
                class: "rightStyle",
                prop: "controller"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.controller,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => $data.editform.controller = $event),
                  placeholder: "请选择控制方式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "集选",
                    value: "集选"
                  }), _createVNode(_component_el_option, {
                    label: "并联",
                    value: "并联"
                  }), _createVNode(_component_el_option, {
                    label: "群控",
                    value: "群控"
                  }), _createVNode(_component_el_option, {
                    label: "按钮",
                    value: "按钮"
                  }), _createVNode(_component_el_option, {
                    label: "信号控制",
                    value: "信号控制"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备代码",
                class: "rightStyle",
                prop: "lifeCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.lifeCode,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => $data.editform.lifeCode = $event),
                  placeholder: "请输入设备代码",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备类别",
                class: "rightStyle",
                prop: "lifeKind"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.lifeKind,
                  "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => $data.editform.lifeKind = $event),
                  onChange: _cache[59] || (_cache[59] = $event => $options.getliftType($data.editform.lifeKind, 1)),
                  placeholder: "请选择设备类别",
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.eqptypeList, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "上端站",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.upStation,
                  "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $data.editform.upStation = $event),
                  placeholder: "请输入上端站",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备品种",
                class: "rightStyle",
                prop: "liftType"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.liftType,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => $data.editform.liftType = $event),
                  placeholder: "请选择设备品种",
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liftTypeList, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.liftType,
                      label: item.liftType,
                      value: item.liftType
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "下端站",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.downStation,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => $data.editform.downStation = $event),
                  placeholder: "请输入下端站",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "基站",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.baseStation,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => $data.editform.baseStation = $event),
                  placeholder: "请输入基站",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "产品型号",
                class: "rightStyle",
                prop: "liftModel"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.liftModel,
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => $data.editform.liftModel = $event),
                  placeholder: "请输入产品型号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "产品编号",
                class: "rightStyle",
                prop: "liftNum"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.liftNum,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => $data.editform.liftNum = $event),
                  placeholder: "请输入产品编号",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "悬挂装置规格",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.hangType,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => $data.editform.hangType = $event),
                  placeholder: "请输入悬挂装置规格",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "悬挂装置数量",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.hangNum,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => $data.editform.hangNum = $event),
                  placeholder: "请输入悬挂装置数量",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "制造单位",
                class: "rightStyle",
                prop: "createUnit"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.createUnit,
                  "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => $data.editform.createUnit = $event),
                  placeholder: "请输入制造单位",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "监督检验依据",
                style: {
                  "width": "440px"
                },
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.proof,
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => $data.editform.proof = $event),
                  placeholder: "请输入监督检验依据",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "防爆等级",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.flameProof,
                  "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => $data.editform.flameProof = $event),
                  placeholder: "请输入防爆等级",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "燃爆物质",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.material,
                  "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => $data.editform.material = $event),
                  placeholder: "请输入燃爆物质",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "制造执行标准",
                class: "rightStyle",
                prop: "createStandard"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.createStandard,
                  "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => $data.editform.createStandard = $event),
                  placeholder: "请选择制造执行标准",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "JG135-2000",
                    value: "JG135-2000"
                  }), _createVNode(_component_el_option, {
                    label: "GB25194-2010",
                    value: "GB25194-2010"
                  }), _createVNode(_component_el_option, {
                    label: "GB7588-1995",
                    value: "GB7588-1995"
                  }), _createVNode(_component_el_option, {
                    label: "GB7588-2003(不含第1号修改单)",
                    value: "GB7588-2003(不含第1号修改单)"
                  }), _createVNode(_component_el_option, {
                    label: "GB7588-2003（含第1号修改单）",
                    value: "GB7588-2003（含第1号修改单）"
                  }), _createVNode(_component_el_option, {
                    label: "GB/T16899-2011",
                    value: "GB/T16899-2011"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "维护保养单位",
                class: "rightStyle",
                prop: "maintenance"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.maintenance,
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => $data.editform.maintenance = $event),
                  style: {
                    "width": "300px"
                  },
                  placeholder: "请输入维护保养单位",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "整机防爆标志",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.materialSign,
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => $data.editform.materialSign = $event),
                  placeholder: "请输入整机防爆标志",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安全钳类型",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.safetyGear,
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => $data.editform.safetyGear = $event),
                  placeholder: "请选择安全钳类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "滚柱型瞬时式",
                    value: "滚柱型瞬时式"
                  }), _createVNode(_component_el_option, {
                    label: "楔块型瞬时式",
                    value: "楔块型瞬时式"
                  }), _createVNode(_component_el_option, {
                    label: "渐进式",
                    value: "渐进式"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "改造单位",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.updateUnit,
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => $data.editform.updateUnit = $event),
                  placeholder: "请输入改造单位",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  style: {
                    "width": "300px"
                  },
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "受检单位电话",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.testedNum,
                  "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => $data.editform.testedNum = $event),
                  placeholder: "请输入受检单位电话",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "缓冲器形式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.bufferForm,
                  "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => $data.editform.bufferForm = $event),
                  placeholder: "请选择缓冲器形式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "非线性蓄能型",
                    value: "非线性蓄能型"
                  }), _createVNode(_component_el_option, {
                    label: "线性蓄能型",
                    value: "线性蓄能型"
                  }), _createVNode(_component_el_option, {
                    label: "耗能型",
                    value: "耗能型"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "改造日期格式",
                prop: "updateDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.updateDateType,
                  "onUpdate:modelValue": _cache[79] || (_cache[79] = $event => $data.editform.updateDateType = $event),
                  onChange: _cache[80] || (_cache[80] = $event => _ctx.getDateType($data.editform.updateDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "改造日期",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.updateDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.updateDate,
                  "onUpdate:modelValue": _cache[81] || (_cache[81] = $event => $data.editform.updateDate = $event),
                  type: "date",
                  placeholder: "改造日期",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.updateDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.updateDate,
                  "onUpdate:modelValue": _cache[82] || (_cache[82] = $event => $data.editform.updateDate = $event),
                  type: "date",
                  placeholder: "改造日期",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.updateDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.updateDate,
                  "onUpdate:modelValue": _cache[83] || (_cache[83] = $event => $data.editform.updateDate = $event),
                  type: "date",
                  placeholder: "改造日期",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "监督检验日期格式",
                prop: "superviseDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.superviseDateType,
                  "onUpdate:modelValue": _cache[84] || (_cache[84] = $event => $data.editform.superviseDateType = $event),
                  onChange: _cache[85] || (_cache[85] = $event => _ctx.getDateType($data.editform.superviseDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "监督检验日期",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.superviseDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.superviseDate,
                  "onUpdate:modelValue": _cache[86] || (_cache[86] = $event => $data.editform.superviseDate = $event),
                  type: "date",
                  placeholder: "监督检验日期",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.superviseDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.superviseDate,
                  "onUpdate:modelValue": _cache[87] || (_cache[87] = $event => $data.editform.superviseDate = $event),
                  type: "date",
                  placeholder: "监督检验日期",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.superviseDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.superviseDate,
                  "onUpdate:modelValue": _cache[88] || (_cache[88] = $event => $data.editform.superviseDate = $event),
                  type: "date",
                  placeholder: "监督检验日期",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "拖动方式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.drag,
                  "onUpdate:modelValue": _cache[89] || (_cache[89] = $event => $data.editform.drag = $event),
                  placeholder: "请选择 拖动方式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "交流调压调频调速",
                    value: "交流调压调频调速"
                  }), _createVNode(_component_el_option, {
                    label: "交流调压调速",
                    value: "交流调压调速"
                  }), _createVNode(_component_el_option, {
                    label: "交流单速",
                    value: "交流单速"
                  }), _createVNode(_component_el_option, {
                    label: "交流双速",
                    value: "交流双速"
                  }), _createVNode(_component_el_option, {
                    label: "直流调速",
                    value: "直流调速"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "监督检测类型",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.superviseType,
                  "onUpdate:modelValue": _cache[90] || (_cache[90] = $event => $data.editform.superviseType = $event),
                  placeholder: "请选择监督检测类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "安装",
                    value: "安装"
                  }), _createVNode(_component_el_option, {
                    label: "重大修理",
                    value: "并联"
                  }), _createVNode(_component_el_option, {
                    label: "改造",
                    value: "改造"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "制动器形式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.brakeForm,
                  "onUpdate:modelValue": _cache[91] || (_cache[91] = $event => $data.editform.brakeForm = $event),
                  placeholder: "请选择制动器形式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "机电式",
                    value: "机电式"
                  }), _createVNode(_component_el_option, {
                    label: "非机电式",
                    value: "非机电式"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用登记机关",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.organ,
                  "onUpdate:modelValue": _cache[92] || (_cache[92] = $event => $data.editform.organ = $event),
                  placeholder: "请输入使用登记机关",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "悬挂装置",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.hang,
                  "onUpdate:modelValue": _cache[93] || (_cache[93] = $event => $data.editform.hang = $event),
                  placeholder: "请选择悬挂装置",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "钢丝绳",
                    value: "钢丝绳"
                  }), _createVNode(_component_el_option, {
                    label: "链条",
                    value: "链条"
                  }), _createVNode(_component_el_option, {
                    label: "无",
                    value: "无"
                  }), _createVNode(_component_el_option, {
                    label: "钢带",
                    value: "钢带"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "紧急救援电话",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.erpNum,
                  "onUpdate:modelValue": _cache[94] || (_cache[94] = $event => $data.editform.erpNum = $event),
                  placeholder: "请输入紧急救援电话",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "顶升形式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.jacking,
                  "onUpdate:modelValue": _cache[95] || (_cache[95] = $event => $data.editform.jacking = $event),
                  placeholder: "请选择顶升形式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "间接式",
                    value: "间接式"
                  }), _createVNode(_component_el_option, {
                    label: "直接式",
                    value: "直接式"
                  }), _createVNode(_component_el_option, {
                    label: "/",
                    value: "/"
                  }), _createVNode(_component_el_option, {
                    label: "钢带",
                    value: "钢带"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安全管理人员",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.safety,
                  "onUpdate:modelValue": _cache[96] || (_cache[96] = $event => $data.editform.safety = $event),
                  style: {
                    "width": "300px"
                  },
                  placeholder: "请输入安全管理人员",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开门形式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.openForm,
                  "onUpdate:modelValue": _cache[97] || (_cache[97] = $event => $data.editform.openForm = $event),
                  placeholder: "请选择开门形式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "自动",
                    value: "自动"
                  }), _createVNode(_component_el_option, {
                    label: "手动",
                    value: "手动"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安全管理人员电话",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.safetyNum,
                  "onUpdate:modelValue": _cache[98] || (_cache[98] = $event => $data.editform.safetyNum = $event),
                  placeholder: "请输入安全管理人员电话",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "名义宽度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  type: "number",
                  modelValue: $data.editform.nominalWidth,
                  "onUpdate:modelValue": _cache[99] || (_cache[99] = $event => $data.editform.nominalWidth = $event),
                  placeholder: "请输入名义宽度",
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "重大修理单位",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.majorUnit,
                  "onUpdate:modelValue": _cache[100] || (_cache[100] = $event => $data.editform.majorUnit = $event),
                  placeholder: "请输入重大修理单位",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "名义速度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.nominalSpeed,
                  "onUpdate:modelValue": _cache[101] || (_cache[101] = $event => $data.editform.nominalSpeed = $event),
                  placeholder: "请输入名义速度",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "施工单位",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.buildUnit,
                  "onUpdate:modelValue": _cache[102] || (_cache[102] = $event => $data.editform.buildUnit = $event),
                  placeholder: "请输入施工单位",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "倾斜角",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.tilt,
                  "onUpdate:modelValue": _cache[103] || (_cache[103] = $event => $data.editform.tilt = $event),
                  placeholder: "请输入倾斜角",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "输送能力",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.conveying,
                  "onUpdate:modelValue": _cache[104] || (_cache[104] = $event => $data.editform.conveying = $event),
                  placeholder: "请输入输送能力",
                  style: {
                    "width": "300px"
                  },
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "重大修理日期格式",
                prop: "majorDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.majorDateType,
                  "onUpdate:modelValue": _cache[105] || (_cache[105] = $event => $data.editform.majorDateType = $event),
                  onChange: _cache[106] || (_cache[106] = $event => _ctx.getDateType($data.editform.majorDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "重大修理时间",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.majorDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.majorDate,
                  "onUpdate:modelValue": _cache[107] || (_cache[107] = $event => $data.editform.majorDate = $event),
                  type: "date",
                  placeholder: "重大修理时间",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.majorDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.majorDate,
                  "onUpdate:modelValue": _cache[108] || (_cache[108] = $event => $data.editform.majorDate = $event),
                  type: "date",
                  placeholder: "重大修理时间",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.majorDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.majorDate,
                  "onUpdate:modelValue": _cache[109] || (_cache[109] = $event => $data.editform.majorDate = $event),
                  type: "date",
                  placeholder: "重大修理时间",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "下次检测日期格式",
                prop: "nextDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.nextDateType,
                  "onUpdate:modelValue": _cache[110] || (_cache[110] = $event => $data.editform.nextDateType = $event),
                  onChange: _cache[111] || (_cache[111] = $event => _ctx.getDateType($data.editform.nextDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "下次检测时间",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.nextDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.nextDate,
                  "onUpdate:modelValue": _cache[112] || (_cache[112] = $event => $data.editform.nextDate = $event),
                  type: "date",
                  placeholder: "下次检测时间",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.nextDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.nextDate,
                  "onUpdate:modelValue": _cache[113] || (_cache[113] = $event => $data.editform.nextDate = $event),
                  type: "date",
                  placeholder: "下次检测时间",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.nextDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.nextDate,
                  "onUpdate:modelValue": _cache[114] || (_cache[114] = $event => $data.editform.nextDate = $event),
                  type: "date",
                  placeholder: "下次检测时间",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "提升高度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.liftingHeight,
                  "onUpdate:modelValue": _cache[115] || (_cache[115] = $event => $data.editform.liftingHeight = $event),
                  placeholder: "请输入提升高度",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "轿门位置",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.doorPosition,
                  "onUpdate:modelValue": _cache[116] || (_cache[116] = $event => $data.editform.doorPosition = $event),
                  placeholder: "请输入轿门位置",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "使用区段长度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  modelValue: $data.editform.section,
                  "onUpdate:modelValue": _cache[117] || (_cache[117] = $event => $data.editform.section = $event),
                  placeholder: "请输入使用区段长度",
                  style: {
                    "width": "300px"
                  },
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "电动机型号",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: $data.editform.electricModel,
                  "onUpdate:modelValue": _cache[118] || (_cache[118] = $event => $data.editform.electricModel = $event),
                  style: {
                    "width": "300px"
                  },
                  placeholder: "请输入电动机型号",
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "驱动方式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.driving,
                  "onUpdate:modelValue": _cache[119] || (_cache[119] = $event => $data.editform.driving = $event),
                  placeholder: "请选择驱动方式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "曳引式",
                    value: "曳引式"
                  }), _createVNode(_component_el_option, {
                    label: "强制式",
                    value: "强制式"
                  }), _createVNode(_component_el_option, {
                    label: "液压",
                    value: "液压"
                  }), _createVNode(_component_el_option, {
                    label: "齿轮齿条式",
                    value: "齿轮齿条式"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "桥厢尺寸宽度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.bridgeBoxWidth,
                  "onUpdate:modelValue": _cache[120] || (_cache[120] = $event => $data.editform.bridgeBoxWidth = $event),
                  placeholder: "请输入桥厢尺寸宽度",
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "机房形式",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.computer,
                  "onUpdate:modelValue": _cache[121] || (_cache[121] = $event => $data.editform.computer = $event),
                  placeholder: "请选择机房形式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "有机房",
                    value: "有机房"
                  }), _createVNode(_component_el_option, {
                    label: "无机房",
                    value: "无机房"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "桥厢尺寸深度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.bridgeBoxDeep,
                  "onUpdate:modelValue": _cache[122] || (_cache[122] = $event => $data.editform.bridgeBoxDeep = $event),
                  placeholder: "请输入桥厢尺寸深度",
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "驱动主机布置",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.assign,
                  "onUpdate:modelValue": _cache[123] || (_cache[123] = $event => $data.editform.assign = $event),
                  placeholder: "请选择驱动主机布置",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "井道内上置",
                    value: "井道内上置"
                  }), _createVNode(_component_el_option, {
                    label: "井道内下置",
                    value: "井道内下置"
                  }), _createVNode(_component_el_option, {
                    label: "上置机房内",
                    value: "上置机房内"
                  }), _createVNode(_component_el_option, {
                    label: "侧置机房内",
                    value: "侧置机房内"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "桥厢尺寸高度",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "number",
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.bridgeBoxHigth,
                  "onUpdate:modelValue": _cache[124] || (_cache[124] = $event => $data.editform.bridgeBoxHigth = $event),
                  placeholder: "请输入桥厢尺寸高度",
                  min: 0,
                  clearable: "",
                  autocomplete: "off",
                  "show-word-limit": "",
                  maxlength: "50",
                  required: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "下次检验日期格式",
                prop: "nextTestDateType",
                style: {
                  "width": "440px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  style: {
                    "width": "300px"
                  },
                  modelValue: $data.editform.nextTestDateType,
                  "onUpdate:modelValue": _cache[125] || (_cache[125] = $event => $data.editform.nextTestDateType = $event),
                  onChange: _cache[126] || (_cache[126] = $event => _ctx.getDateType($data.editform.nextTestDateType)),
                  placeholder: "请选择日期格式",
                  clearable: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "年月日",
                    value: '年月日'
                  }), _createVNode(_component_el_option, {
                    label: "年月",
                    value: '年月'
                  }), _createVNode(_component_el_option, {
                    label: "年",
                    value: '年'
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]), _createElementVNode("div", null, [_createVNode(_component_el_form_item, {
                label: "下次检验时间",
                class: "rightStyle"
              }, {
                default: _withCtx(() => [$data.editform.nextTestDateType === '年月日' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: $data.editform.nextTestDate,
                  "onUpdate:modelValue": _cache[127] || (_cache[127] = $event => $data.editform.nextTestDate = $event),
                  type: "date",
                  placeholder: "下次检验时间",
                  format: "YYYY年MM月DD日",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.nextTestDateType === '年月' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 1,
                  modelValue: $data.editform.nextTestDate,
                  "onUpdate:modelValue": _cache[128] || (_cache[128] = $event => $data.editform.nextTestDate = $event),
                  type: "date",
                  placeholder: "下次检验时间",
                  format: "YYYY年MM月",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true), $data.editform.nextTestDateType === '年' ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 2,
                  modelValue: $data.editform.nextTestDate,
                  "onUpdate:modelValue": _cache[129] || (_cache[129] = $event => $data.editform.nextTestDate = $event),
                  type: "date",
                  placeholder: "下次检验时间",
                  format: "YYYY年",
                  style: {
                    "width": "300px"
                  }
                }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          })], 512), [[_vShow, $data.editform.specialType === 1]])]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.BackDialog,
    "onUpdate:modelValue": _cache[135] || (_cache[135] = $event => $data.BackDialog = $event),
    title: "通知",
    "lock-scroll": false,
    width: "80%"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
      onClick: _cache[133] || (_cache[133] = $event => $data.BackDialog = false)
    }, {
      default: _withCtx(() => [...(_cache[160] || (_cache[160] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[134] || (_cache[134] = $event => $options.recordBack())
    }, {
      default: _withCtx(() => [...(_cache[161] || (_cache[161] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_cache[162] || (_cache[162] = _createElementVNode("span", null, "将清除记录,视频和图片", -1))]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.showBack,
    "onUpdate:modelValue": _cache[138] || (_cache[138] = $event => $data.showBack = $event),
    title: "生成备忘录",
    "lock-scroll": false,
    width: "80%"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
      onClick: _cache[136] || (_cache[136] = $event => $data.showBack = false)
    }, {
      default: _withCtx(() => [...(_cache[165] || (_cache[165] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[137] || (_cache[137] = $event => $options.creatNotice())
    }, {
      default: _withCtx(() => [...(_cache[166] || (_cache[166] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("view", null, [_createVNode(_component_el_upload, {
      class: "upload-demo",
      action: this.ip + '/detection/signPic',
      "on-success": $options.handleAvatarSuccess,
      "on-remove": $options.handleRemove,
      limit: 1,
      "before-upload": $options.beforeAvatarUpload,
      ref: "upload"
    }, {
      tip: _withCtx(() => [...(_cache[164] || (_cache[164] = [_createElementVNode("div", {
        class: "el-upload__tip"
      }, " 只能上传jpg/png文件，且不超过2M ", -1)]))]),
      default: _withCtx(() => [_createVNode(_component_el_button, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [...(_cache[163] || (_cache[163] = [_createTextVNode("点击上传客户签名", -1)]))]),
        _: 1
      })]),
      _: 1
    }, 8, ["action", "on-success", "on-remove", "before-upload"])])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}